export const themes = [
    {
        name: "繽紛色",
        headerBackgroundColor: "#b6bbbb",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#cad2d2",
        indexColumnFontColor: "#000000",
        mainBackgroundColor: "#ffffff",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#c5a6a1",
            體育: "#d8b6a2",
            軍訓: "#aeb4c7",
            外語: "#a1a9a3",
            通識: "#c2cfc6",
            選修: "#e3cda0",
            自訂: "#aebed1",
        },
    },
    {
        name: "自然綠",
        headerBackgroundColor: "#eaeae8",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#eaeae8",
        indexColumnFontColor: "#000000",
        mainBackgroundColor: "#ffffff",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#dadbc9",
            體育: "#e5ddc6",
            軍訓: "#b6b4bf",
            外語: "#dad2c5",
            通識: "#c1b59d",
            選修: "#b1b3a6",
            自訂: "#a8b7a7",
        },
    },
    {
        name: "煙霧藍",
        headerBackgroundColor: "#b6bbbb",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#cad2d2",
        indexColumnFontColor: "#000000",
        mainBackgroundColor: "#f4f4f2",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#6f8090",
            體育: "#d0d0c4",
            軍訓: "#acb9bf",
            外語: "#c5c5d1",
            通識: "#c9c0bc",
            選修: "#979aac",
            自訂: "#919faf",
        },
    },
    {
        name: "原野綠",
        headerBackgroundColor: "#e0ddd6",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#e0ddd6",
        indexColumnFontColor: "#000000",
        mainBackgroundColor: "#ffffff",
        borderColor: "#4b3728",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#C7C49D",
            體育: "#e8d8bf",
            軍訓: "#f4ebdc",
            外語: "#babdb4",
            通識: "#cdc0a6",
            選修: "#e0d9bd",
            自訂: "#d3d1c8",
        },
    },
    {
        name: "甜甜色",
        headerBackgroundColor: "#dcdcdc",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#dcdcdc",
        indexColumnFontColor: "#000000",
        mainBackgroundColor: "#ffffff",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#e6e6fa",
            體育: "#f0fff0",
            軍訓: "#faebd7",
            外語: "#f5f5dc",
            通識: "#fff0f5",
            選修: "#f0f8ff",
            自訂: "#fafad2",
        },
    },
    {
        name: "紫色",
        headerBackgroundColor: "#c9b6fd",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#c9b6fd",
        indexColumnFontColor: "#000000",
        mainBackgroundColor: "#ffffff",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#dacefe",
            體育: "#bda6fe",
            軍訓: "#aeb4c7",
            外語: "#a1a9a3",
            通識: "#bda6fe",
            選修: "#c9b6fd",
            自訂: "#aebed1",
        },
    },
    {
        name: "莫蘭迪色",
        headerBackgroundColor: "#D2CABF",
        indexColumnBackgroundColor: "#D2CABF",
        mainBackgroundColor: "#ffffff",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#D4B8B4",
            體育: "#BECBD3",
            軍訓: "#aeb4c7",
            外語: "#E3D0CC",
            通識: "#DFBFB2",
            選修: "#DCDDD5",
        },
    },
    {
        name: "彩霞",
        headerBackgroundColor: "#E0E0E0",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#E0E0E0",
        indexColumnFontColor: "#000000",
        mainBackgroundColor: "#ffffff",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#FFBDC9",
            體育: "#FFED97",
            軍訓: "#aeb4c7",
            外語: "#97CBFF",
            通識: "#CECEFF",
            選修: "#A3D1D1",
            自訂: "#aebed1",
        },
    },
    {
        name: "繽紛色",
        headerBackgroundColor: "#b6bbbb",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#cad2d2",
        indexColumnFontColor: "#000000",
        mainBackgroundColor: "#ffffff",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#FF7675",
            體育: "#FFEAA7",
            軍訓: "#aeb4c7",
            外語: "#55EFC4",
            通識: "#A28BFE",
            選修: "#81ECEC",
            自訂: "#aebed1",
        },
    },
    {
        name: "深色-煙霧藍",
        headerBackgroundColor: "#b6bbbb",
        headerFontColor: "#000000",
        indexColumnBackgroundColor: "#cad2d2",
        indexColumnFontColor: "#003377",
        mainBackgroundColor: "#000000",
        borderColor: "#003377",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#6f8090",
            體育: "#d0d0c4",
            軍訓: "#acb9bf",
            外語: "#c5c5d1",
            通識: "#c9c0bc",
            選修: "#979aac",
            自訂: "#919faf",
        },
    },
    {
        name: "深色-繽紛色",
        headerBackgroundColor: "#666666",
        headerFontColor: "#ffff",
        indexColumnBackgroundColor: "#666666",
        indexColumnFontColor: "#fffff",
        mainBackgroundColor: "#666666",
        borderColor: "#ffffff",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#c5a6a1",
            體育: "#d8b6a2",
            軍訓: "#aeb4c7",
            外語: "#a1a9a3",
            通識: "#c2cfc6",
            選修: "#e3cda0",
            自訂: "#aebed1",
        },
    },
    {
        name: "深色-繽紛色2",
        headerBackgroundColor: "#a0a0a0",
        headerFontColor: "#ffffff",
        indexColumnBackgroundColor: "#4A4A4A",
        indexColumnFontColor: "#ffffff",
        mainBackgroundColor: "#212121",
        borderColor: "#ffffff",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#CFCFCF",
            體育: "#d8b6a2",
            軍訓: "#aeb4c7",
            外語: "#a1a9a3",
            通識: "#c2cfc6",
            選修: "#CFCFCF",
            自訂: "#aebed1",
        },
    },
    {
        name: "深色-dark",
        headerBackgroundColor: "#274249",
        headerFontColor: "#ADA399",
        indexColumnBackgroundColor: "#274249",
        indexColumnFontColor: "#ADA399",
        mainBackgroundColor: "#1A2C30",
        borderColor: "#000000",
        courseFontColor: "#000000",
        courseBackgroundColor: {
            必修: "#D5A030",
            體育: "#FAE4AB",
            軍訓: "#FAE4AB",
            外語: "#FAE4AB",
            通識: "#FAE4AB",
            選修: "#D5A030",
            自訂: "#aebed1",
        },
    },
    {
        name: "深色-灰階風",
        headerBackgroundColor: "#4f4f4f",
        headerFontColor: "#ffffff",
        indexColumnBackgroundColor: "#4f4f4f",
        indexColumnFontColor: "#ffffff",
        mainBackgroundColor: "#9d9d9d",
        borderColor: "#ffffff",
        courseFontColor: "#ffffff",
        courseBackgroundColor: {
            必修: "#930000",
            體育: "#977c00",
            軍訓: "#844200",
            外語: "#467500",
            通識: "#3a006f",
            選修: "#003060",
            自訂: "#aebed1",
        },
    },
];
